import React, { Component } from 'react';
import { Container, Label } from 'reactstrap';
import { observer } from 'mobx-react';
import { inject } from 'mobx-react';
import DataWrapper from './../../../principal/containers/DataWrapper';
import { FiltroRelAnalitico } from '../components/FiltroRelAnalitico';
import { buscaBaixarVazio } from '../../../../utils/mensagens';
import Footer from './../../../comum/components/Footer';
import { RelatorioAnaliticoStore } from '../stores/RelatorioAnaliticosStore';
import ModalAviso from '../../../comum/components/ModalAviso';


@inject("store")
@DataWrapper
@observer
export class RelatorioAnalitico extends Component {

    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.controller = new RelatorioAnaliticoStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Relatório Analítico");
    };

    modalErro() {
        if(this.controller.mensagemErro !== "") {
            return <ModalAviso onClickFechar={this.controller.fecharMensagemErro}>
                <h2>
                    {this.controller.mensagemErro}
                </h2>
            </ModalAviso>
        }
    }

    render() {
        return(
            <div>
                <Container fluid>
                    {this.modalErro}
                    <FiltroRelAnalitico controller={this.controller} />
                    <Label>
                        {buscaBaixarVazio}
                    </Label>
                    <Footer>
                    </Footer>
                </Container>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatorioanalitico/telas/RelatorioAnalitico.js